import { SaveAnalyticsParams } from "./interfaces/analytics.interface";
import { request } from "./utils";

const SaveAnalyticsData = (data: SaveAnalyticsParams) => {
  return request("analytics", "post", { data });
};

export { SaveAnalyticsData };
